import React from 'react';
import { useNotifications } from '../contexts/NotificationContext';
import { FiArrowLeft, FiBell, FiSettings, FiFilter } from 'react-icons/fi';

const Header = () => {
  const { 
    currentService, 
    currentThread, 
    goBack, 
    markAllNotificationsAsRead, 
    markCurrentServiceAsRead,
    showSettings,
    setShowSettings,
    services
  } = useNotifications();

  // Get display name for current service
  const getDisplayName = () => {
    if (currentService) {
      const service = services.find(s => s.name === currentService);
      return service ? service.displayName || service.name : currentService;
    }
    return currentService;
  };

  // Determine title based on navigation state
  const getTitle = () => {
    if (showSettings) {
      return 'Settings';
    } else if (currentThread) {
      return 'Thread Details';
    } else if (currentService) {
      return getDisplayName();
    } else {
      return 'My Notifications';
    }
  };

  const handleGoBack = () => {
    if (showSettings) {
      setShowSettings(false);
    } else {
      goBack();
    }
  };

  return (
    <header className="app-header">
      <div className="header-title">
        {(currentService || currentThread || showSettings) && (
          <FiArrowLeft className="back-button" onClick={handleGoBack} />
        )}
        <span>{getTitle()}</span>
      </div>
      <div className="header-actions">
        {!currentThread && !showSettings && (
          <>
            <FiFilter className="header-icon" title="Filter" />
            <FiBell 
              className="header-icon" 
              title={currentService ? "Mark all as read" : "Mark all notifications as read"}
              onClick={currentService ? markCurrentServiceAsRead : markAllNotificationsAsRead}
            />
          </>
        )}
        {!showSettings && (
          <FiSettings 
            className="header-icon" 
            title="Settings" 
            onClick={() => setShowSettings(true)}
          />
        )}
      </div>
    </header>
  );
};

export default Header;